"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _recharts = require("recharts");

var _formatters = require("../../util/formatters");

require("./SimplePieChart.scss");

require("./SimplePieChartDark.scss");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SimplePieChart = function SimplePieChart(_ref) {
  var data = _ref.data,
      width = _ref.width,
      height = _ref.height,
      colors = _ref.colors,
      title = _ref.title,
      innerRadius = _ref.innerRadius,
      outerRadius = _ref.outerRadius,
      currentValue = _ref.currentValue,
      paddingAngle = _ref.paddingAngle,
      onMouseEnter = _ref.onMouseEnter;

  var _useState = (0, _react.useState)({
    active: false,
    index: -1
  }),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      toggleHover = _useState2[1];

  var handleOnMouseEnter = function handleOnMouseEnter(entry, active, index) {
    toggleHover({
      active: active,
      index: index
    });

    if (onMouseEnter && typeof onMouseEnter === 'function') {
      onMouseEnter(_objectSpread(_objectSpread({}, entry), {}, {
        activeIndex: index
      }));
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-simple-pie-chart",
    style: {
      width: "".concat(width, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, {
    width: width,
    height: height
  }, /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
    data: data,
    dataKey: "value",
    nameKey: "name",
    cx: "50%",
    cy: "50%",
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    fill: "#82ca9d",
    paddingAngle: paddingAngle
  }, data.map(function (entry, index) {
    return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, {
      key: "cell-".concat(index),
      onMouseEnter: function onMouseEnter() {
        return handleOnMouseEnter(entry, true, index);
      },
      onMouseLeave: function onMouseLeave() {
        return toggleHover({
          active: false,
          index: index
        });
      },
      fill: colors[index % colors.length],
      stroke: hover.active && index === hover.index ? colors[index % colors.length] : 'transparent',
      strokeWidth: 6
    });
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("span", null, title), /*#__PURE__*/_react["default"].createElement("span", null, (0, _formatters.formatNumberQuantity)(currentValue))));
};

var _default = SimplePieChart;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/SimplePieChart/SimplePieChart.js
// module id = 1917
// module chunks = 0